import { isEmpty } from 'lodash'
import parsePhoneNumberFromString from 'libphonenumber-js'

const withPrefix = (value) => {
  if (isEmpty(value)) return ''
  return value?.startsWith('+') ? value : '+' + value
}

const details = (value) => parsePhoneNumberFromString(withPrefix(value))

const number = (value) =>
  details(value)?.formatInternational() || withPrefix(value)

const phone = {
  withPrefix,
  details,
  number,
}

export default phone
